import { confirmDialog, ConfirmDialogReturn } from 'primereact/confirmdialog';
import { InputNumber } from 'primereact/inputnumber';
import React from 'react';

export const getBuyInConfirmDialog = (
  buyInRef: React.MutableRefObject<number>,
  onConfirm: () => void,
): ConfirmDialogReturn => {
  const onAccept = (): void => {
    onConfirm();
    buyInRef.current = null;
  };

  return confirmDialog({
    message: (
      <>
        <label htmlFor="buyin-input" className="block mb-2">
          Enter buyIn:
        </label>
        <InputNumber
          id="buyin-input"
          value={buyInRef.current || undefined}
          onChange={e => (buyInRef.current = e.value)}
          inputClassName="buyin-input"
        />
        BB
      </>
    ),
    className: 'buyin-dialog w-auto',
    header: 'BuyIn (optional)',
    icon: 'pi pi-money-bill',
    acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
    accept: onAccept,
  });
};
